import React, { useState } from 'react';

import Switch from 'core/components/switch';

// One setting for every sidebar, so support can switch someone back to the standard layout in one place
const STORAGE_KEY = 'sidebarLayout:useCustom';

const readUseCustomLayout = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) !== 'false';
  } catch {
    return true;
  }
};

/** Whether to show the user's own sidebar layout (default) or the standard one. */
export const useCustomSidebarLayout = () => {
  const [useCustomLayout, setUseCustomLayout] = useState(readUseCustomLayout);
  const toggleCustomLayout = () => {
    setUseCustomLayout(!useCustomLayout);
    try {
      localStorage.setItem(STORAGE_KEY, String(!useCustomLayout));
    } catch {
      // Storage full or blocked: the switch still applies, it just won't be remembered
    }
  };
  return [useCustomLayout, toggleCustomLayout];
};

export const SidebarLayoutToggle = ({ useCustomLayout, onToggle, className }) => (
  <Switch
    id="useCustomSidebarLayout"
    label="Use my layout"
    value={useCustomLayout}
    onChange={onToggle}
    mode="light"
    className={className}
  />
);
